import { CardImage, Pricing } from '.';
import { MouseEvent } from 'react';
import { getProductURL } from '@/features/navigation/utils/url-helpers';
import { handleShowPageLoading } from '@/features/page-loading/utils/show-loading';
import useDeleteWishlist from '@/app/(pdp)/_utils/use-delete-wishlist';
import { FavoriteCardProps } from './types';
import { AppNextLink } from '../app-next-link';
import { IconHeartFilled } from '../icons';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { Webengage } from '../webengage';
import { SupportedEvents } from '../webengage/types';
export const FavoriteCard = ({
  product,
  brand,
  id,
  image,
  isLazy,
  name,
  onWishlistDelete,
  pricingProps,
  slug,
  isSalable
}: FavoriteCardProps) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    mutateAsync: mutateDelete
  } = useDeleteWishlist();
  const handleClick = (event: MouseEvent) => !event.ctrlKey && handleShowPageLoading();
  const handleRemoveFromWishlist = async (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      await mutateDelete({
        productId: id || ''
      });
      Webengage.trackWhishlist(product ?? {}, SupportedEvents.remove_from_favorite);
      onWishlistDelete?.(id);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const imageSize = isMobile ? 140 : 156;
  return <AppNextLink prefetch={false} href={getProductURL(slug || '')} className='relative flex h-full flex-col gap-1 rounded p-2 focus-visible:outline-none' onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="FavoriteCard" data-sentry-source-file="favorite-card.tsx">
            <CardImage alt={name} image={image} srcSet={{
      desktop: 130,
      mobile: 175
    }} isLazy={isLazy} imageClassName='h-auto w-35 aspect-square lg:w-39 mx-auto' width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="favorite-card.tsx" />

            <div className='flex grow flex-col justify-between gap-2'>
                <div className='flex flex-col gap-1 text-caption-12 lg:text-body-14'>
                    <span className='text-text-darkGray'>{brand}</span>

                    <h3 className='line-clamp-2 text-text-black'>{name}</h3>
                </div>

                <div className='flex w-full items-center justify-between'>
                    <button onClick={handleRemoveFromWishlist} aria-label='Remove from wishlist'>
                        <IconHeartFilled className='h-6 w-6 text-primary-main' data-sentry-element="IconHeartFilled" data-sentry-source-file="favorite-card.tsx" />
                    </button>

                    {!isSalable ? <span className='self-end pt-5 text-center text-caption-12 lg:w-22 lg:pt-6 lg:text-body-14'>
                            ناموجود
                        </span> : <Pricing {...pricingProps} />}
                </div>
            </div>
        </AppNextLink>;
};